<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :md="6" :sm="12"  v-if="$store.getters.application.applicationType=='platform'">
            <a-form-item :label="language['premission.applicationName']">
              <a-select v-model="selectedApplicationId" allowClear  >
                <a-select-option v-for="(item,index) in applicationOptions" :key="index" :value="item.id" allowClear>
                  {{ item.applicationName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item :label="language['premission.menuCategory']">
              <a-select v-model="selectedMenuCategory" allowClear>
                <a-select-option value="web">web</a-select-option>
                <a-select-option value="app">app</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">{{language['common.insertButton']}}</a-button>
      <a-button
        @click="batchDel"
        v-if="selectedRowKeys.length > 0"
        ghost
        type="primary"
        icon="delete">{{language['common.batchDelete']}}
      </a-button>
    </div>

    <!-- table区域-begin -->
    <div>

      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i>{{language['common.choosed']}}&nbsp;<a style="font-weight: 600">{{
        selectedRowKeys.length }}</a>{{language['common.item']}}&nbsp;&nbsp;
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        :columns="columns"
        :scroll="{x: 1500}"
        size="middle"
        :pagination="false"
        :dataSource="dataSource"
        :loading="loading"
        :expandedRowKeys="expandedRowKeys"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @expandedRowsChange="handleExpandedRowsChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">{{language['common.edit']}}</a>

          <a-divider type="vertical"/>
          <a-dropdown>
            <a class="ant-dropdown-link">
              {{language['common.more']}} <a-icon type="down"/>
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a href="javascript:;" @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="handleAddSub(record)">{{language['premission.addSubmenu']}}</a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="handleDataRule(record)">{{language['premission.dataType']}}</a>
              </a-menu-item>

              <a-menu-item>
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
        <span slot="menuType" slot-scope="text, record">
          {{ text === 0 ? language['premission'] : (text===1?language['premission'] :(text==2?language['premission.BP']:text)) }}
        </span>
        <!-- 字符串超长截取省略号显示 -->
        <span slot="url" slot-scope="text">
          <j-ellipsis :value="text" :length="25"/>
        </span>
        <!-- 字符串超长截取省略号显示-->
        <span slot="component" slot-scope="text">
          <j-ellipsis :value="text"/>
        </span>
      </a-table>

    </div>
    <!-- table区域-end -->

    <permission-modal ref="modalForm" @ok="modalFormOk"></permission-modal>
    <permission-data-rule-list ref="PermissionDataRuleList" @ok="modalFormOk"></permission-data-rule-list>

  </a-card>
</template>

<script>
  import PermissionModal from './modules/PermissionModal'
  import { getPermissionList,applicationList } from '@/api/api'
  import { getAction, deleteAction, putAction, postAction, httpAction,downFile } from '@/api/manage'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import PermissionDataRuleList from './PermissionDataRuleList'
  import JEllipsis from '@/components/jeecg/JEllipsis'

  export default {
    name: 'PermissionList',
    mixins: [JeecgListMixin],
    components: {
      PermissionDataRuleList,
      PermissionModal,
      JEllipsis
    },
    data() {
      return {
        // 表头
        // columns: columns,
        loading: false,
        // 展开的行，受控属性
        expandedRowKeys: [],
        url: {
          // list: '/sys/permission/list',
          list: this.$store.getters.application.applicationType=='platform'?"/sys/permission/list":"/sys/permission/list?applicationId="+this.$store.getters.application.id,
          delete: '/sys/permission/delete',
          deleteBatch: '/sys/permission/deleteBatch'
        },
        applicationOptions:[],
        selectedApplicationId:'',
        selectedMenuCategory:'',
      }
    },
    created() {
      /*if(this.$store.getters.application.applicationType!='platform'){
        this.selectedApplicationId = this.$store.getters.application.id;
      }else{
        this.selectedApplicationId = ''
        this.initApplicationList();
      }
      this.loadData()*/
      this.initApplicationList();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return [
            {
              title: this.language['premission.name'],
              dataIndex: 'name',
              key: 'name'
            },{
              title: this.language['premission.applicationName'],
              dataIndex: 'applicationName',
              key: 'applicationName'
            }, {
              title: this.language['premission.menuType'],
              dataIndex: 'menuType',
              key: 'menuType',
              scopedSlots: {customRender: 'menuType'},
             /* customRender: function(text) {
                if (text == 0) {
                  return this.$store.getters.language['eletronicSigned.taskText']
                } else if (text == 1) {
                  return '菜单'
                } else if (text == 2) {
                  return '按钮/权限'
                } else {
                  return text
                }
              }*/
            },
            {
              title: 'icon',
              dataIndex: 'icon',
              key: 'icon'
            },
            {
              title:  this.language['premission.component'],
              dataIndex: 'component',
              key: 'component',
              scopedSlots: { customRender: 'component' }
            },
            {
              title:  this.language['premission.url'],
              dataIndex: 'url',
              key: 'url',
              scopedSlots: { customRender: 'url' }
            },
            {
              title: this.language['common.sort'],
              dataIndex: 'sortNo',
              key: 'sortNo'
            },
            {
              title: this.language['common.action'],
              dataIndex: 'action',
              fixed: 'right',
              scopedSlots: { customRender: 'action' },
              align: 'center',
              width: 150
            }
          ]
        }
      }
    },
    methods: {
      handleAdd:function(){
        this.$refs.modalForm.title = this.language['common.add']
        if(this.$store.getters.application.applicationType!='platform'){
          this.$refs.modalForm.add(this.$store.getters.application.id)
        }else{
          this.$refs.modalForm.add()
        }
      },
      handleEdit: function(record) {
        this.$refs.modalForm.title = this.language['common.edit']
        this.$refs.modalForm.edit(record)
      },
      handleDetail(record){
        this.$refs.modalForm.title = this.language['common.detailsButton']
        this.$refs.modalForm.disableSubmit = true;
        this.$refs.modalForm.edit(record)
      },
      searchQuery(){
        this.loadData();
      },
      searchReset(){
        this.selectedApplicationId = '';
        this.selectedMenuCategory = '';
        this.loadData();
      },
      initApplicationList(){
        let that = this;
        getAction("/sys/sysBmApplication/queryListByUser").then((res) => {
          if(res.success){
            that.applicationOptions = res.result;
            console.log('this.applicationOptions: ',this.applicationOptions)
          }
        })
      },
      loadData() {
        this.dataSource = []
        let param={}
        if(this.selectedApplicationId){
          param.applicationId = this.selectedApplicationId
        }
        if(this.selectedMenuCategory){
          param.menuCategory = this.selectedMenuCategory
        }
        getAction(this.url.list,param).then((res) => {
          if (res.success) {
            console.log(res.result)
            this.dataSource = res.result
          }
        })
      },
      // 打开数据规则编辑
      handleDataRule(record) {
        this.$refs.PermissionDataRuleList.edit(record)
      },
      handleAddSub(record) {
        this.$refs.modalForm.title = this.language['premission.addSubmenu'];
        this.$refs.modalForm.disableSubmit = false;
        this.loadParentExtInfo(record);
      },
      loadParentExtInfo(record){
        let that = this;
        let parentId = record.id;
        let _extInfo = "";
        if(parentId){
          getAction("/sys/permission/getSysPermissionByPid",{pid: parentId}).then((res) => {
            if (res.success) {
              _extInfo = res.result.extInfo;
            }
            that.$refs.modalForm.edit({status:'1',permsType:'1',route:true,'parentId':record.id,menuType:1,'applicationId':record.applicationId, extInfo:_extInfo,menuCategory:record.menuCategory});
          })
        } else {
          that.$refs.modalForm.edit({status:'1',permsType:'1',route:true,'parentId':record.id,menuType:1,'applicationId':record.applicationId, extInfo:_extInfo,menuCategory:record.menuCategory});
        }
      },
      handleExpandedRowsChange(expandedRows) {
        this.expandedRowKeys = expandedRows
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>